import { Box, styled } from "@mui/material";
import Skeleton from "react-loading-skeleton";
import BannerImg from "../../assets/images/banner.jpg";
import Logo from "../../assets/logos/logo.png";

const MainContent = styled(Box)(
  // width: 100% when screen narrower than 641px is very important
  // as it scale banner image within it to 100% if the image original width is lower than screen width.
  () => `
    height: -webkit-fill-available;
    margin: 0 auto;
    width: 100%;

    @media (min-width: 641px) {
      width: 84%;
    }

    @media (min-width: 900px) {
      width: 80%;
    }

    & > * {
      padding-left: 20px;
      padding-right: 20px;

      @media (min-width: 641px) {
        padding-left: 0;
        padding-right: 0;
      }
    }
  `,
);

const LogoBanner = styled(Box)(
  () => `
    display: flex;
    justify-content: space-between;
    z-index: 10;
    min-height: 58px;
    width: 100%;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(20px);
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    & .logo {
      width: 170px;
      height: 28px;
    }
  `,
);

type AuthenticateLayoutPro = {
  bannerTopperImage?: any;
  background?: any;
  bannerImageCorner?: any;
  isLoading: any;
  children: any;
  button?: any;
  hideLogo?: boolean;
  hideBackground?: boolean;
  defaultBackground?: any;
};

const AuthenticateLayout = ({
  bannerTopperImage,
  background,
  bannerImageCorner,
  isLoading,
  children,
  button,
  hideLogo,
  hideBackground,
  defaultBackground,
}: AuthenticateLayoutPro) => {
  const optionalImageProps = !bannerImageCorner
    ? {}
    : {
        style: {
          borderRadius:
            bannerImageCorner === "custom" ? "15px" : bannerImageCorner,
          margin: "10px 10px 0 10px",
          width: "calc(100% - 20px)",
        },
      };

  const AppLogo = (
    <img
      className="logo"
      src={
        process.env.REACT_APP_LOGO
          ? "/assets/logo/" + process.env.REACT_APP_LOGO
          : Logo
      }
      alt="logo"
    />
  );

  return (
    <>
      {!hideLogo && (
        <LogoBanner>
          {isLoading ? <Skeleton /> : AppLogo}
          <div>{button?.()}</div>
        </LogoBanner>
      )}
      <MainContent>
        {!hideBackground &&
          (isLoading ? (
            <Skeleton />
          ) : (
            <>
              {bannerTopperImage ? (
                <img
                  className="img custom banner"
                  alt="banner"
                  id="AuthenticateLayout--bannerTopperImage"
                  src={bannerTopperImage}
                />
              ) : null}
              <img
                className={`img ${background ? "custom" : ""} banner`}
                alt="banner"
                id="AuthenticateLayout--background"
                src={
                  background ||
                  (defaultBackground !== undefined
                    ? defaultBackground
                    : BannerImg)
                }
                {...optionalImageProps}
              />
            </>
          ))}
        {children}
      </MainContent>
    </>
  );
};

export default AuthenticateLayout;
